import Services from 'store/Services';
import { AnyAction, MiddlewareAPI } from 'redux';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import { buildLogger } from '@instinet-analytics/core-lib';
import {
    ConfirmAddWidgetsAction,
    LayoutRendererActionType,
} from 'layoutRenderer/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { buildTilesConfigSlice } from 'widgets/tiles/store/config/configSlice';

export const capsuleContainerMiddleware = (services: Services) => [
    addSymbolInfoOnCapsuleContainerAdded(services),
];

const {
    selectors: { selectConfigState },
    actions: { createUpdateConfigAction },
} = buildTilesConfigSlice();

export function addSymbolInfoOnCapsuleContainerAdded(services: Services) {
    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: ConfirmAddWidgetsAction) => {
            const { loggingService, widgetsService } = services;

            const logger = buildLogger(
                'CapsuleContainer addSymbolInfoOnCapsuleContainerAdded',
                loggingService
            );

            next(action);

            if (action.type !== LayoutRendererActionType.CONFIRM_ADD_WIDGETS) {
                return;
            }

            const { ids } = action.payload!;

            const tile = ids.find((i) => i.widgetType === WidgetType.TILES);

            if (tile) {
                const { widgetType, widgetKey } = tile;

                if (widgetType !== WidgetType.TILES) {
                    return;
                }

                const state = middlewareAPI.getState();

                const config = selectConfigState(state, widgetKey);

                if (config.tiles.length > 0) {
                    return;
                }

                const nextWidgetId = widgetsService.getNextWidgetId(
                    WidgetType.SYMBOL_INFO_CAPSULE
                );

                const updateConfigAction = createUpdateConfigAction(widgetKey, {
                    tiles: [
                        {
                            widgetType: WidgetType.SYMBOL_INFO_CAPSULE,
                            widgetKey: nextWidgetId,
                        },
                    ],
                });

                logger.debug(
                    `Adding symbol info capsule ${nextWidgetId} for capsule container ${widgetKey}`
                );

                middlewareAPI.dispatch(updateConfigAction);
            }
        };
}
